import { z } from 'zod';

export const realtimeIdvSchema = z.object({
    idNumber: z.string({ error: 'ID Number is required' })
        .regex(/^\d+$/, "ID Number must be numeric"),
    firstName: z.string().optional().or(z.literal('')),
    surname: z.string().optional().or(z.literal('')),
    yourReference: z.string().optional().or(z.literal('')),
    voucherCode: z.string().optional().or(z.literal('')),
});

export type RealtimeIdvPayload = z.infer<typeof realtimeIdvSchema>;

export const realtimeIdvService = {
    createPayload: (formData: z.infer<typeof realtimeIdvSchema>): RealtimeIdvPayload => {
        return {
            ...formData
        };
    },

    executeReport: async (payload: RealtimeIdvPayload): Promise<any> => {
        const axios = (await import('../axiosConfig')).default;
        const response = await axios.post('/verification/realtime-idv', payload);
        return response.data;
    }
};
